import { Component } from "@angular/core";

@Component({
	selector: "app-qa",
	templateUrl: "./qa.component.html",
	standalone: false,
})
export class QaComponent {
	loading: boolean = false;

	constructor() {}
}
